import { PortfolioBalance } from 'types/DomainTypes';
import { httpGet } from 'utils';

export interface PortfolioBalancesResponse {
  data: PortfolioBalance[];
  size?: number;
}

export const fetchPortfolioBalances = () => httpGet<PortfolioBalancesResponse>('portal/PortfolioStatements');
